import React from 'react';
import {connect} from "react-redux";
import {Trans, withTranslation} from "react-i18next";
import Button from "@material-ui/core/Button";
import {exportLabelBicycleScanHistoryToCsv, loadLabelBicycleScanHistory} from "core/actions/bicycle-actions";
import BsPanelLoader from "components/panel/loader/BsPanelLoader";
import BsPanelHeader from "components/panel/header/BsPanelHeader";
import BsDataTable from "components/data-table/BsDataTable";
import BsPanel from "components/panel/BsPanel";
import BsPanelTitle from "components/panel/header/BsPanelTitle";
import LABEL_BICYCLE_SCAN_HISTORY from "./label-bicycle-scan-history";
import BsPanelHeaderFilters from "components/panel/header/BsPanelHeaderFilters";
import LabelBicycleScanHistoryFilters from "./LabelBicycleScanHistoryFilters";

const queryString = require('query-string');

const FILTER_FIELDS = ['system', 'location', 'user', 'date'];

class LabelBicycleScanHistory extends React.Component {

  constructor(props) {
    super(props);
    const query = queryString.parse(this.props.location.search);
    this.state = {
      sort: query.sort,
      direction: query.direction,
      fields: {
        system: query.system != null ? query.system : '',
        location: query.location != null ? query.location : '',
        user: query.user != null ? query.user : '',
        date: query.date != null ? query.date : ''
      }
    };

    this.onLoadData(query);
  }

  onRequestSort = (params) => {
    this.setState({
      sort: params.sort,
      direction: params.direction
    });
    this.onLoadData(params);
  }

  handleChange(field, e) {
    let fields = this.state.fields;
    fields[field] = e.target.value;
    this.setState({fields});
  }

  onHandleFilter = () => {
    const params = queryString.parse(this.props.location.search);
    params.system = this.state.fields.system;
    params.location = this.state.fields.location;
    params.user = this.state.fields.user;
    params.date = this.state.fields.date;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
  }

  onHandleClear = () => {
    const params = queryString.parse(this.props.location.search);
    delete params.system;
    delete params.location;
    delete params.user;
    delete params.date;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
    this.setState({
      ...this.state,
      fields: {
        system: '',
        location: '',
        user: '',
        date: ''
      }
    })
  }

  onLoadData = (query) => {
    this.props.loadLabelBicycleScanHistory(this.props.match.params.labelId, this.prepareQuery(query));
  }

  onRowClick = (row) => {
    this.props.history.push('/label/' + this.props.match.params.labelId + '/scan-bicycles/' + row.location.id + '/' + row.user.id + '/' + row.scanDate)
  }

  hasAppliedFilter = () => {
    const query = queryString.parse(this.props.location.search);
    return FILTER_FIELDS.some((field) => !!query[field]);
  }

  export = () => {
    const query = queryString.parse(this.props.location.search);
    this.props.exportLabelBicycleScanHistoryToCsv(this.props.match.params.labelId, this.prepareQuery(query));
  }

  prepareQuery = (query) => {
    if (query.sort) {
      query.sort = query.sort + ',' + query.direction;
    }

    return query
  }

  render() {
    return (
      <BsPanel padding={true}>
        <BsPanelLoader show={this.props.loading}/>
        <BsPanelHeader>
          <BsPanelTitle action={
            <span title={this.hasAppliedFilter() ? '' : this.props.t('bicycle_scan_history.export_requires_filter_hint')}>
              <Button variant="outlined"
                      type="button"
                      disabled={!this.hasAppliedFilter()}
                      onClick={this.export}>
                <Trans i18nKey="general.export"/>
              </Button>
            </span>
          }>
            <Trans i18nKey="bicycle_scan_history.title"/>
          </BsPanelTitle>
        </BsPanelHeader>

        <BsPanelHeaderFilters onHandleFilter={this.onHandleFilter.bind(this)}
                              onHandleClear={this.onHandleClear.bind(this)}>
          <LabelBicycleScanHistoryFilters fields={this.state.fields}
                                          onHandleChange={this.handleChange.bind(this)}/>
        </BsPanelHeaderFilters>

        <BsDataTable location={this.props.location}
                     history={this.props.history}
                     order={this.state.direction}
                     orderBy={this.state.sort}
                     settings={LABEL_BICYCLE_SCAN_HISTORY}
                     content={this.props.scanHistory}
                     onRowClick={this.onRowClick}
                     onChangePage={this.onLoadData}
                     onChangeSize={this.onLoadData}
                     onRequestSort={this.onRequestSort}/>

      </BsPanel>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    scanHistory: state.bicycle.scanHistory,
    loading: state.bicycle.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadLabelBicycleScanHistory: (labelId, query) => {
      dispatch(loadLabelBicycleScanHistory(labelId, query));
    },
    exportLabelBicycleScanHistoryToCsv: (labelId, query) => {
      dispatch(exportLabelBicycleScanHistoryToCsv(labelId, query));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LabelBicycleScanHistory));
